import gsap from "gsap";
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";

export default class UI {
  constructor() {
    document
      .querySelector("#volumeBtn")
      .addEventListener("click", this.onVolume.bind(this));
  }
  init() {
    this.screenActive = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
    this.events.addEventListener("GAME_EVENTS", this.onEvents.bind(this));

    Global.timeTaken;
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "start_time":
        this.showHeader();
        this.showTray();
        this.startTimer();
        break;
      case "show_volume":
        this.showVolume();
        break;
      case "hide_header":
        document.querySelector("#game_header").classList.remove("active");
        document.querySelector("#game_header").classList.remove("active2");
        document
          .querySelector("#game_header .type1")
          .classList.remove("active");
        document
          .querySelector("#game_header .type2")
          .classList.remove("active");
        break;
      case "time_up":
      case "end_game":
        this.stopTimer();
        this.showScore();
        break;
    }
  }
  showScore() {
    // console.log("Game Time:", this.gameTime);

    Global.timeTaken = 90 - this.gameTime;
    Global.serverObj.send(Global.URL_DATA, null, null, {
      saveType: "score",
      score: Global.collectedTotal,
      time: 90 - this.gameTime,
      uniqID: Global.U_ID,
      utm_source: Global.utm_source,
      at_ptr_name: Global.at_ptr_name,
      utm_campaign: Global.utm_campaign,
      at_format: Global.at_format,
    });

    // console.log(90 - this.gameTime)

    // Global.serverObj.send(
    //   Global.URL_UPLOAD,
    //   null,
    //   null,
    //   {
    //     uniqID: Global.U_ID,
    //     timeTaken: 90 - this.gameTime,
    //   },
    //   "POST",
    //   null,
    //   false,
    // );

    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "send_Time",
        data: {
          timeTaken_360: 90 - this.gameTime,
        },
      },
    });

    setTimeout(() => {
      document.querySelector("#game_header").classList.remove("active");
      document.querySelector("#game_header").classList.remove("active2");
      document.querySelector("#item_tray").classList.remove("active");
      document.querySelector("#item_tray").classList.remove("active2");
      document.querySelector("#gyroButton").classList.remove("active");

      this.events.dispatchEvent({
        type: "GAMESCENE_EVENTS",
        message: {
          event_type: "show_screen",
          data: {
            screenKey: "Result",
          },
        },
      });
    }, 1500);
  }
  showHeader() {
    document.querySelector("#game_header").classList.remove("active");
    document.querySelector("#game_header").classList.remove("active2");

    document.querySelector("#game_header .type1").classList.remove("active");
    document.querySelector("#game_header .type2").classList.add("active");
    setTimeout(() => {
      document.querySelector("#game_header").classList.add("active");
    }, 0);
    setTimeout(() => {
      document.querySelector("#game_header").classList.add("active2");
    }, 10);
  }
  showVolume() {
    document.querySelector("#game_header").classList.add("active");
    document.querySelector("#game_header .type1").classList.add("active");
    document.querySelector("#game_header .type2").classList.remove("active");
    setTimeout(() => {
      document.querySelector("#game_header").classList.add("active2");
    }, 0);
  }

  showTray() {
    document.querySelector("#item_tray").classList.add("active");
    document.querySelector("#gyroButton").classList.add("active");

    setTimeout(() => {
      document.querySelector("#item_tray").classList.add("active2");
    }, 10);
  }
  startTimer() {
    this.gameTime = 90;
    document.querySelector("#game_header .timer_sec .label").innerHTML =
      this.gameTime;

    setTimeout(() => {
      this.timerInt = setInterval(() => {
        this.gameTime--;
        document.querySelector("#game_header .timer_sec .label").innerHTML =
          this.gameTime;

        if (this.gameTime <= 0) {
          // clearInterval(this.timerInt);
          this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: { event_type: "time_up" },
          });
        }
      }, 1000);
    }, 500);
  }
  stopTimer() {
    clearInterval(this.timerInt);
  }
  onVolume() {
    Global.soundEnabled = !Global.soundEnabled;

    if (Global.soundEnabled) {
      document.querySelector("#BGAudio").play();
      document.querySelector("#volumeBtn").classList.remove("disabled");
    } else {
      document.querySelector("#BGAudio").pause();
      document.querySelector("#volumeBtn").classList.add("disabled");
    }
  }
}
